/* translated labels come from window.MV2_T (snippets/mv2-bottom.liquid); requests go through the visitor's language root */
window.mv2t = function (k, d) { var t = window.MV2_T; return (t && t[k]) || d; };
window.mv2root = window.mv2root || ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/');
/* MAVIFY v2 — prototype behaviors: carousel arrows, ghost-text reveal,
   lookbook hotspots. No dependencies; degrades gracefully. */
(function () {
  document.addEventListener('click', function (e) {
    var prev = e.target.closest('[data-mv2-prev]');
    var next = e.target.closest('[data-mv2-next]');
    if (prev || next) {
      var id = (prev || next).getAttribute(prev ? 'data-mv2-prev' : 'data-mv2-next');
      var row = document.querySelector('[data-mv2-row="' + id + '"]');
      if (row) {
        var tile = row.firstElementChild;
        var w = tile ? tile.getBoundingClientRect().width + 16 : row.clientWidth * 0.8;
        var dir = document.documentElement.getAttribute('dir') === 'rtl' ? -1 : 1;
        row.scrollBy({ left: (prev ? -w : w) * dir, behavior: 'smooth' });
      }
      return;
    }
    var hs = e.target.closest('[data-mv2-hotspot]');
    if (hs) {
      var wrap = hs.closest('[data-mv2-lookbook]');
      var n = hs.getAttribute('data-mv2-hotspot');
      wrap.querySelectorAll('[data-mv2-tooltip]').forEach(function (t) {
        if (t.getAttribute('data-mv2-tooltip') === n) { t.hidden = !t.hidden; }
        else { t.hidden = true; }
      });
    }
  });

  var ghosts = document.querySelectorAll('[data-mv2-ghost]');
  if ('IntersectionObserver' in window && ghosts.length) {
    ghosts.forEach(function (p) {
      var spans = p.querySelectorAll('span');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            spans.forEach(function (sp, i) {
              setTimeout(function () { sp.style.color = '#111'; }, i * 60);
            });
            io.disconnect();
          }
        });
      }, { threshold: 0.35 });
      io.observe(p);
    });
  }
})();

/* ---- MAVIFY v2 drawers: cart (AJAX), search (predictive), login, menu ---- */
(function () {
  var scrim = document.querySelector('[data-mv2-scrim]');
  if (!scrim) return;
  var THRESHOLD = 150000; /* free shipping: 1500 EGP in cents */

  function fmt(cents) {
    return (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' EGP';
  }
  function drawer(name) { return document.querySelector('[data-mv2-drawer="' + name + '"]'); }
  function closeAll() {
    scrim.hidden = true;
    document.querySelectorAll('[data-mv2-drawer]').forEach(function (d) { d.hidden = true; });
    document.documentElement.style.overflow = '';
  }
  function open(name) {
    closeAll();
    var d = drawer(name);
    if (!d) return;
    scrim.hidden = false; d.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    if (name === 'cart') refreshCart();
    if (name === 'search') { var i = d.querySelector('[data-mv2-search-input]'); if (i) setTimeout(function () { i.focus(); }, 150); }
  }

  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    var n = document.querySelector('[data-mv2-cart-n]'); if (n) n.textContent = cart.item_count;
    var box = document.querySelector('[data-mv2-cart-items]');
    if (!box) return;
    if (!cart.items.length) {
      box.innerHTML = '<div style="padding:28px 0;text-align:center;font-size:14px;color:#6B6B67">' + mv2t('cart_empty', 'Your bag is empty.') + '</div>';
    } else {
      box.innerHTML = cart.items.map(function (it, i) {
        var save = it.original_line_price > it.final_line_price;
        return '<div class="mv2-cartline">' +
          '<div style="display:flex;gap:14px">' +
            '<span class="mv2-cartline__thumb">' + (it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/, '_180x$1$2') + '" alt="">' : '') + '</span>' +
            '<div style="flex:1;display:flex;flex-direction:column;gap:6px;min-width:0">' +
              '<div style="font-size:15px;font-weight:600;line-height:1.35;color:#111">' + it.product_title + '</div>' +
              (save ? '<span style="background:var(--mv-sale,#C25A3C);color:#fff;font-size:10.5px;font-weight:600;padding:3px 8px;border-radius:4px;align-self:flex-start">' + mv2t('save', 'SAVE') + ' ' + fmt(it.original_line_price - it.final_line_price) + '</span>' : '') +
              (it.variant_title && it.variant_title !== 'Default Title' ? '<div style="font-size:13px;color:#6B6B67">' + it.variant_title + '</div>' : '') +
              '<div class="mv2-cartline__pm">' + fmt(it.final_line_price) + (save ? '<s>' + fmt(it.original_line_price) + '</s>' : '') + '</div>' +
            '</div>' +
            '<div class="mv2-cartline__pr" style="text-align:end;flex:none">' +
              '<div style="font-size:15px;font-weight:600;color:#111">' + fmt(it.final_line_price) + '</div>' +
              (save ? '<s style="font-size:13px;color:#8B8880">' + fmt(it.original_line_price) + '</s>' : '') +
            '</div>' +
          '</div>' +
          '<div style="display:flex;align-items:center;justify-content:space-between">' +
            '<div class="mv2-cartline__step">' +
              '<button type="button" data-mv2-line="' + (i + 1) + '" data-mv2-d="-1" aria-label="Decrease">−</button>' +
              '<span style="min-width:24px;text-align:center;font-size:13.5px;font-weight:500">' + it.quantity + '</span>' +
              '<button type="button" data-mv2-line="' + (i + 1) + '" data-mv2-d="1" aria-label="Increase">+</button>' +
            '</div>' +
            '<button type="button" class="mv2-cartline__bin" data-mv2-line="' + (i + 1) + '" data-mv2-d="remove" aria-label="Remove"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#111" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M9 7V5h6v2M7 7l1 13h8l1-13M10 11v5M14 11v5"/></svg></button>' +
          '</div>' +
        '</div>';
      }).join('');
    }
    var away = THRESHOLD - cart.total_price;
    var msg = document.querySelector('[data-mv2-ship-msg]');
    var bar = document.querySelector('[data-mv2-ship-bar]');
    if (msg) msg.textContent = away > 0 ? mv2t('ship_away', '%AMOUNT% away from free shipping').replace('%AMOUNT%', fmt(away)) : mv2t('ship_done', 'You’ve unlocked free shipping 🎉');
    if (bar) bar.style.width = Math.min(100, Math.round(cart.total_price * 100 / THRESHOLD)) + '%';
    ['[data-mv2-subtotal]', '[data-mv2-total]', '[data-mv2-total2]'].forEach(function (sel) {
      var el = document.querySelector(sel); if (el) el.textContent = fmt(cart.total_price);
    });
  }
  function refreshCart() {
    fetch(mv2root + 'cart.js').then(function (r) { return r.json(); }).then(renderCart);
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-mv2-open]');
    if (opener) { e.preventDefault(); open(opener.getAttribute('data-mv2-open')); return; }
    if (e.target.closest('[data-mv2-close]') || e.target === scrim) { closeAll(); return; }
    var chk = e.target.closest('[data-mv2-checkout]');
    if (chk) { window.location.href = '/checkout'; return; }
    var note = e.target.closest('[data-mv2-note-toggle]');
    if (note) { var ta = document.querySelector('[data-mv2-note]'); if (ta) ta.hidden = !ta.hidden; return; }
    var step = e.target.closest('[data-mv2-line]');
    if (step) {
      var line = parseInt(step.getAttribute('data-mv2-line'), 10);
      var d = step.getAttribute('data-mv2-d');
      fetch(mv2root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        var q = d === 'remove' ? 0 : Math.max(0, cart.items[line - 1].quantity + parseInt(d, 10));
        return fetch(mv2root + 'cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: line, quantity: q })
        });
      }).then(function (r) { return r.json(); }).then(renderCart);
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* Order note persists on blur */
  var noteEl = document.querySelector('[data-mv2-note]');
  if (noteEl) noteEl.addEventListener('blur', function () {
    fetch(mv2root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: noteEl.value }) });
  });

  /* PDP add-to-cart -> AJAX + toast + drawer (buy-now falls through to /checkout) */
  var pf = document.getElementById('mv2-pdp-form');
  if (pf) {
    pf.addEventListener('submit', function (e) {
      var rt = pf.querySelector('[data-mv2-returnto]');
      if (rt && rt.value === '/checkout') return; /* buy it now: normal submit */
      e.preventDefault();
      var fd = new FormData(pf);
      fetch(mv2root + 'cart/add.js', { method: 'POST', body: fd })
        .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
        .then(function (item) {
          var toast = document.querySelector('[data-mv2-toast]');
          if (toast) {
            var img = toast.querySelector('[data-mv2-toast-img]');
            if (img) img.innerHTML = item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/, '_120x$1$2') + '" alt="" style="max-width:78%;max-height:82%;object-fit:contain;mix-blend-mode:multiply">' : '';
            var txt = toast.querySelector('[data-mv2-toast-txt]');
            if (txt) txt.textContent = item.product_title + ' · ' + fmt(item.final_price);
            toast.hidden = false;
            setTimeout(function () { toast.hidden = true; }, 4000);
          }
          open('cart');
        })
        .catch(function () { pf.submit(); });
    });
  }

  /* Predictive search */
  var si = document.querySelector('[data-mv2-search-input]');
  if (si) {
    var t;
    var box0 = document.querySelector('[data-mv2-search-results]');
    var lab0 = document.querySelector('[data-mv2-search-label]');
    var mv2TrendLabel = lab0 ? lab0.textContent : mv2t('trending', 'Trending now');
    var mv2DefaultResults = box0 ? box0.innerHTML : '';
    si.addEventListener('input', function () {
      clearTimeout(t);
      var q = si.value.trim();
      t = setTimeout(function () {
        var label = document.querySelector('[data-mv2-search-label]');
        var box = document.querySelector('[data-mv2-search-results]');
        if (!q) { if (label) label.textContent = mv2TrendLabel; if (box) box.innerHTML = mv2DefaultResults; return; }
        // predictive search only serves the default language; other languages use the search page feed
        var surl = mv2root === '/'
          ? '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=4'
          : mv2root + 'search?q=' + encodeURIComponent(q) + '&type=product&options[prefix]=last&view=mv2-suggest';
        fetch(surl)
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var prods = (((data || {}).resources || {}).results || {}).products || [];
            if (label) label.textContent = prods.length ? mv2t('results', 'Results') : mv2t('no_results', 'No results');
            if (!box) return;
            box.innerHTML = prods.map(function (p) {
              var price = (p.price || '').replace(/^LE\s*/i, '');
              if (price && !/EGP/i.test(price)) price += ' EGP';
              return '<a class="mv2-dr__sres" href="' + p.url + '" style="background:#F5F5F4;border-radius:14px;padding:14px;display:flex;gap:16px;text-decoration:none">' +
                '<span class="mv2-dr__sthumb" style="width:84px;height:84px;background-color:var(--mv-greige,#E7E5E1);border-radius:10px;display:flex;align-items:center;justify-content:center;overflow:hidden;flex:none">' +
                  (p.image ? '<img src="' + p.image + '" alt="" style="max-width:80%;max-height:84%;object-fit:contain;mix-blend-mode:multiply">' : '') + '</span>' +
                '<span style="flex:1;display:flex;flex-direction:column;gap:5px;min-width:0">' +
                  '<span class="mv2-dr__sname" style="font-size:15px;font-weight:500;color:#111">' + p.title + '</span>' +
                  '<span class="mv2-dr__sprice" style="font-size:14px;font-weight:600;color:#111">' + price + '</span>' +
                  '<button type="button" class="mv2-miniadd" data-mv2-addurl="' + String(p.url).split('?')[0] + '">' +
                    '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M5.5 8h13l-1 12h-11l-1-12z"/><path d="M9 8V6.5a3 3 0 0 1 6 0V8"/><path d="M12 12v4M10 14h4"/></svg>' + mv2t('add_to_cart', 'Add to cart') + '</button>' +
                '</span></a>';
            }).join('') || '<div style="padding:18px 8px;font-size:14px;color:#6B6B67">' + mv2t('no_match', 'No products match — try “serum”, “hair”, or “capixy”.') + '</div>';
          });
      }, 250);
    });
  }

  /* Quick add-to-cart from product tiles -> AJAX + toast + open cart drawer */
  /* data-mv2-stay: keep the shopper where they are (e.g. inside the Jamila chat) —
     the button itself confirms, the toast shows and the bag count updates */
  function mv2Flash(btn, cls, text) {
    var lab = btn.querySelector('[data-mv2-label]');
    if (lab && !btn.dataset.mv2Orig) btn.dataset.mv2Orig = lab.textContent;
    btn.classList.add(cls);
    if (lab && text) lab.textContent = text;
    clearTimeout(btn._mv2t);
    btn._mv2t = setTimeout(function () {
      btn.classList.remove(cls);
      if (lab && btn.dataset.mv2Orig) lab.textContent = btn.dataset.mv2Orig;
    }, 2600);
  }
  function mv2DoAdd(qa, id, qty) {
    var stay = qa.hasAttribute('data-mv2-stay');
    qa.classList.add('is-loading');
    fetch(mv2root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty && qty > 0 ? qty : 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function (item) {
        qa.classList.remove('is-loading');
        var toast = document.querySelector('[data-mv2-toast]');
        // in a full-screen chat on phones the toast would cover the next result's button;
        // the button's own "Added" state and the bag count are the confirmation there
        if (toast && !(stay && window.matchMedia('(max-width: 560px)').matches)) {
          var img = toast.querySelector('[data-mv2-toast-img]');
          if (img) img.innerHTML = item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/, '_120x$1$2') + '" alt="" style="max-width:78%;max-height:82%;object-fit:contain;mix-blend-mode:multiply">' : '';
          var txt = toast.querySelector('[data-mv2-toast-txt]');
          if (txt) txt.textContent = item.product_title + ' · ' + fmt(item.final_price);
          toast.hidden = false;
          setTimeout(function () { toast.hidden = true; }, 4000);
        }
        var bar = qa.closest('.mv2-tile__bar');
        var qi = bar && bar.querySelector('[data-mv2-qtyval]');
        if (qi) qi.value = '1';
        if (stay) { refreshCart(); mv2Flash(qa, 'is-added', qa.getAttribute('data-mv2-added')); }
        else open('cart');
      })
      .catch(function () {
        qa.classList.remove('is-loading');
        if (stay) { mv2Flash(qa, 'is-error', qa.getAttribute('data-mv2-failed')); return; }
        window.location.href = qa.getAttribute('data-href') || '/cart';
      });
  }
  document.addEventListener('click', function (e) {
    var qa = e.target.closest('[data-mv2-quickadd]');
    if (!qa) return;
    e.preventDefault();
    var id = qa.getAttribute('data-variant-id');
    if (!id) { window.location.href = qa.getAttribute('data-href') || '/cart'; return; }
    var bar = qa.closest('.mv2-tile__bar');
    var qi = bar && bar.querySelector('[data-mv2-qtyval]');
    mv2DoAdd(qa, id, qi ? parseInt(qi.value, 10) : 1);
  });
  /* Add a whole routine in one go: data-mv2-addall="handle,handle,…".
     Variants are looked up live; unavailable or option-needing products are skipped
     and the button says how many made it in. Honours data-mv2-stay like single adds. */
  function mv2PostItems(items) {
    return fetch(mv2root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (r.ok) return items.length;
      // one bad line fails the whole batch — fall back to one at a time
      return items.reduce(function (chain, it) {
        return chain.then(function (n) {
          return fetch(mv2root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [it] }) })
            .then(function (x) { return x.ok ? n + 1 : n; }).catch(function () { return n; });
        });
      }, Promise.resolve(0));
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mv2-addall]');
    if (!b) return;
    e.preventDefault();
    if (b.dataset.busy) return;
    var handles = (b.getAttribute('data-mv2-addall') || '').split(',').filter(Boolean);
    if (!handles.length) return;
    var stay = b.hasAttribute('data-mv2-stay');
    b.dataset.busy = '1'; b.classList.add('is-loading');
    Promise.all(handles.map(function (h) {
      return fetch(mv2root + 'products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (ps) {
      var items = [], okHandles = [];
      ps.forEach(function (p, i) {
        if (!p) return;
        var vs = p.variants || [];
        if (vs.length > 1) return;                       // needs a choice — leave to the product page
        var v = vs.filter(function (x) { return x.available; })[0];
        if (v) { items.push({ id: v.id, quantity: 1 }); okHandles.push(handles[i]); }
      });
      if (!items.length) return { n: 0, okHandles: [] };
      return mv2PostItems(items).then(function (n) { return { n: n, okHandles: n === items.length ? okHandles : [] }; });
    }).then(function (o) {
      b.classList.remove('is-loading'); delete b.dataset.busy;
      if (!o.n) { mv2Flash(b, 'is-error', b.getAttribute('data-mv2-failed')); return; }
      var scope = b.closest('[data-mv2-addall-scope]') || document;
      o.okHandles.forEach(function (h) {
        scope.querySelectorAll('[data-mv2-addurl="/products/' + h + '"]').forEach(function (x) { mv2Flash(x, 'is-added', x.getAttribute('data-mv2-added')); });
      });
      var msg = o.n < handles.length
        ? (b.getAttribute('data-mv2-partial') || mv2t('added_partial', 'Added %N% of %T%')).replace('%N%', o.n).replace('%T%', handles.length)
        : b.getAttribute('data-mv2-added');
      mv2Flash(b, 'is-added', msg);
      if (stay) refreshCart(); else open('cart');
    }).catch(function () {
      b.classList.remove('is-loading'); delete b.dataset.busy;
      mv2Flash(b, 'is-error', b.getAttribute('data-mv2-failed'));
    });
  });
  /* search suggestions have no variant id — look it up, then add */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mv2-addurl]');
    if (!b) return;
    e.preventDefault();
    if (b.dataset.busy) return;
    b.dataset.busy = '1';
    b.classList.add('is-loading');
    var url = b.getAttribute('data-mv2-addurl');
    fetch(url + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var vs = p.variants || [];
        var stay = b.hasAttribute('data-mv2-stay');
        b.classList.remove('is-loading'); delete b.dataset.busy;
        if (stay && vs.length > 1) { window.location.href = url; return; }   // needs a size/option choice
        var v = vs.filter(function (x) { return x.available; })[0] || (stay ? null : vs[0]);
        if (v) { mv2DoAdd(b, v.id); return; }
        if (stay) {
          b.disabled = true;
          var lab = b.querySelector('[data-mv2-label]');
          if (lab) lab.textContent = b.getAttribute('data-mv2-soldout') || mv2t('sold_out', 'Sold out');
          return;
        }
        window.location.href = url;
      })
      .catch(function () {
        b.classList.remove('is-loading'); delete b.dataset.busy;
        if (b.hasAttribute('data-mv2-stay')) { mv2Flash(b, 'is-error', b.getAttribute('data-mv2-failed')); return; }
        window.location.href = url;
      });
  });
})();

/* ---- Brands mega menu: hover-intent open, gap-proof, click to pin ---- */
(function () {
  document.querySelectorAll('.mv2-header__brands').forEach(function (wrap) {
    var t;
    var btn = wrap.querySelector('.mv2-header__brandsbtn');
    function show() { clearTimeout(t); wrap.classList.add('is-open'); }
    function hide() { clearTimeout(t); t = setTimeout(function () { wrap.classList.remove('is-open'); }, 200); }
    wrap.addEventListener('mouseenter', show);
    wrap.addEventListener('mouseleave', hide);
    if (btn) btn.addEventListener('click', function (e) { e.preventDefault(); wrap.classList.toggle('is-open'); });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) wrap.classList.remove('is-open'); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') wrap.classList.remove('is-open'); });
  });
})();

/* ---- Tile wishlist toggle (localStorage; feeds the future wishlist drawer) ---- */
(function () {
  var KEY = 'mavify:wishlist';
  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
  function sync() {
    var list = read();
    document.querySelectorAll('[data-mv2-wish]').forEach(function (b) {
      b.classList.toggle('is-wished', list.indexOf(b.getAttribute('data-mv2-wish')) > -1);
    });
  }
  document.addEventListener('click', function (e) {
    var w = e.target.closest('[data-mv2-wish]');
    if (!w) return;
    e.preventDefault();
    var h = w.getAttribute('data-mv2-wish');
    if (!h) return;
    var list = read(); var i = list.indexOf(h);
    if (i > -1) list.splice(i, 1); else list.push(h);
    write(list); sync();
  });
  sync();
})();

/* ---- Cart drawer suggestion card (client-side; avoids layout-snippet liquid limits) ---- */
(function () {
  var box = document.querySelector('[data-mv2-sug]');
  if (!box) return;
  var loaded = false;
  /* /products.json gives a major-unit string ("375.00"); /recommendations/
     products.json gives cents as a number (37500). Normalize both. */
  function fmtP(p) {
    var n = parseFloat(p);
    if (typeof p === 'number' || (typeof p === 'string' && p.indexOf('.') === -1)) n = n / 100;
    return n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' EGP';
  }
  function card(p) {
    var img = (p.images && p.images[0] && (p.images[0].src || p.images[0])) || (p.featured_image) || '';
    var price = p.variants && p.variants[0] ? fmtP(p.variants[0].price) : '';
    box.innerHTML = '<div style="background:#F5F5F4;border-radius:16px;padding:14px;display:flex;gap:14px">' +
      '<span style="width:76px;height:76px;background-color:var(--mv-greige,#E7E5E1);border-radius:10px;display:flex;align-items:center;justify-content:center;overflow:hidden;flex:none">' +
        (img ? '<img src="' + img + '" alt="" loading="lazy" style="max-width:80%;max-height:84%;object-fit:contain;mix-blend-mode:multiply">' : '') + '</span>' +
      '<div style="flex:1;display:flex;flex-direction:column;gap:4px;min-width:0">' +
        '<div style="font-size:14.5px;font-weight:600;color:#111">' + p.title + '</div>' +
        '<div style="font-size:13.5px;color:#3B3B37">' + price + '</div>' +
        (p.variants && p.variants[0]
          ? '<button type="button" class="mv2-miniadd" data-mv2-quickadd data-variant-id="' + p.variants[0].id + '" data-href="/products/' + p.handle + '">' +
            '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M5.5 8h13l-1 12h-11l-1-12z"/><path d="M9 8V6.5a3 3 0 0 1 6 0V8"/><path d="M12 12v4M10 14h4"/></svg>' + mv2t('add_to_cart', 'Add to cart') + '</button>'
          : '<a href="/products/' + p.handle + '" class="mv2-miniadd">Add to cart</a>') +
      '</div></div>';
  }
  function loadSug() {
    if (loaded) return; loaded = true;
    fetch(mv2root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      if (cart.items.length) {
        return fetch(mv2root + 'recommendations/products.json?product_id=' + cart.items[0].product_id + '&limit=1')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            if (d.products && d.products.length) { card(d.products[0]); }
            else { throw new Error('none'); }
          });
      }
      throw new Error('empty');
    }).catch(function () {
      fetch(mv2root + 'products.json?limit=1').then(function (r) { return r.json(); }).then(function (d) {
        if (d.products && d.products.length) card(d.products[0]);
      });
    });
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-mv2-open="cart"]')) { loaded = false; loadSug(); }
  });
  /* also fill when the PDP auto-opens the drawer after ATC */
  var mo = new MutationObserver(function () {
    var d = document.querySelector('[data-mv2-drawer="cart"]');
    if (d && !d.hidden) loadSug();
  });
  var dEl = document.querySelector('[data-mv2-drawer="cart"]');
  if (dEl) mo.observe(dEl, { attributes: true, attributeFilter: ['hidden'] });
})();

  /* External links (e.g. majestic.bio) open in a new tab, site-wide */
  (function () {
    function markExternal(root) {
      (root || document).querySelectorAll('a[href^="http"]:not([target])').forEach(function (a) {
        try {
          if (a.hostname && a.hostname !== window.location.hostname) {
            a.setAttribute('target', '_blank');
            a.setAttribute('rel', 'noopener noreferrer');
          }
        } catch (e) {}
      });
    }
    markExternal(document);
    if (window.MutationObserver) {
      new MutationObserver(function (muts) {
        muts.forEach(function (mu) {
          Array.prototype.forEach.call(mu.addedNodes, function (n) {
            if (n.nodeType === 1) markExternal(n);
          });
        });
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  })();


/* ---- Product card quantity stepper ----
   Delegated so it works for cards rendered later (load more, search, drawers). */
(function () {
  function clamp(n) { return Math.max(1, Math.min(99, isFinite(n) ? n : 1)); }
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-mv2-qtystep]');
    if (!step) return;
    e.preventDefault();
    e.stopPropagation();          // must not reach the card's link
    var box = step.closest('[data-mv2-tileqty]');
    var input = box && box.querySelector('[data-mv2-qtyval]');
    if (!input) return;
    input.value = clamp(parseInt(input.value, 10) + parseInt(step.getAttribute('data-mv2-qtystep'), 10));
  });
  document.addEventListener('input', function (e) {
    var input = e.target.closest('[data-mv2-qtyval]');
    if (input) input.value = input.value.replace(/[^0-9]/g, '');
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-mv2-qtyval]');
    if (input) input.value = clamp(parseInt(input.value, 10));
  });
  // typing in the field must not follow the card link
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-mv2-qtyval]')) { e.preventDefault(); e.stopPropagation(); }
  });
})();
